<template>
  <v-app
    class="pos-relative"
    :style="{ overflow, background }"
    :class="{ 'top-dialog': useEmbedded }"
  >
    <v-main class="pt-0">
      <router-view :active-layout-component="activeLayoutComponent" />
      <app-resources />
    </v-main>
  </v-app>
</template>

<script setup>
import AppResources from "#src/AppResources.vue";
import EmbeddedModalLayout from "#src/layouts/EmbeddedModalLayout.vue";
import EmbeddedWidgetLayout from "#src/layouts/EmbeddedWidgetLayout.vue";
import WebappLayout from "#src/layouts/WebappLayout.vue";

import { computed, inject, markRaw } from "vue";

import { useInstanceSettingsStore } from "#src/stores/instance-settings";

const pinia = inject("pinia");

const instance = useInstanceSettingsStore(pinia);

if (instance.queryPrefillForValue(v => v?.use_modal === "true")) {
  instance.use_modal = true;
} else if (instance.queryPrefillForValue(v => v?.use_webapp === "true")) {
  instance.use_webapp = true;
} else {
  instance.isInternallyEmbedded = true;
}

const background = computed(() => {
  if (instance.use_modal) return "transparent";
  return null;
});
const overflow = computed(() => {
  if (instance.use_modal) return "hidden";
  return "auto";
});

const useEmbedded = computed(() => instance.isInternallyEmbedded);

let activeLayoutComponent;

if (instance.use_modal) {
  activeLayoutComponent = markRaw(EmbeddedModalLayout);
} else if (instance.isInternallyEmbedded) {
  activeLayoutComponent = markRaw(EmbeddedWidgetLayout);
} else if (instance.use_webapp) {
  activeLayoutComponent = markRaw(WebappLayout);
} else {
  throw "NO LAYOUT SPECIFIED";
}
</script>

<style lang="scss">
.top-dialog {
  .v-dialog {
    position: absolute;
    top: 0;
  }
}
</style>
